module.exports = __webpack_public_path__ + "static/media/HeroSection.232a6a07.png";